export const projectsViewRoute = {
	path: '/projects/view/:projectId*',
	name: 'projectsView',
	component: () => import('@/pages/projects/ProjectsView.vue'),
};

export const welcomeRoute = {
	path: '/welcome',
	name: 'welcome',
	component: () => import('@/pages/welcome/WelcomeIndex.vue'),
};

export const packageConfigureRoute = {
	path: '/settings/package/configure',
	name: 'settingsPackageConfigure',
	component: () =>
		import('@/pages/settings/packageConfigure/PackageConfigurePage.vue'),
};
